/**
 * Tablo siralama yardimcilari.
 *
 * NEDEN ORTAK: Her rapor sekmesinde elle sorter yazilinca kimi kolon
 * siralanabilir kimi degil, sayilar metin gibi siralanir (100 < 25 < 5) ve
 * Turkce karakterler yanlis yere duser (Çiğdem, Ömer, Şule). Eren Bey'in
 * "yazilari siraliyor ama sayilari yapmiyor" geri bildirimi tam olarak bu.
 *
 * KULLANIM SINIRI: Bunlar ISTEMCI tarafi siralayicilardir - yalnizca elindeki
 * tum veri bellekteyken dogru sonuc verir. Liste SUNUCU tarafinda sayfaliysa
 * (backend'e page/per_page gidiyorsa) bunlari KULLANMA; o zaman yalnizca
 * gorunen sayfa siralanir ve kullanici yaniltilir. O listelerde
 * `sorter: true` + backend orderBy gerekir (bkz. RoutinesReportTab).
 */

/** Metin: Turkce alfabeye gore, bos degerler sona. */
export const textSorter = (key) => (a, b) => {
  const x = a?.[key];
  const y = b?.[key];
  if (x == null || x === '') return y == null || y === '' ? 0 : 1;
  if (y == null || y === '') return -1;
  return String(x).localeCompare(String(y), 'tr');
};

/** Sayi: metin gibi degil sayisal karsilastirma. Bos degerler sona. */
export const numberSorter = (key) => (a, b) => {
  const x = a?.[key];
  const y = b?.[key];
  const xBos = x == null || x === '';
  const yBos = y == null || y === '';
  if (xBos) return yBos ? 0 : 1;
  if (yBos) return -1;
  return Number(x) - Number(y);
};

/** Tarih/saat: ISO ya da YYYY-MM-DD biciminde metin karsilastirmasi dogru sonuc verir. */
export const dateSorter = (key) => (a, b) => {
  const x = a?.[key];
  const y = b?.[key];
  if (!x) return !y ? 0 : 1;
  if (!y) return -1;
  return new Date(x) - new Date(y);
};

/** Ic ice alan icin (ornegin r.student.name). */
export const pathTextSorter = (getter) => (a, b) => {
  const x = getter(a);
  const y = getter(b);
  if (x == null || x === '') return y == null || y === '' ? 0 : 1;
  if (y == null || y === '') return -1;
  return String(x).localeCompare(String(y), 'tr');
};
